// 全局 Cookie 安全标志补丁：
// 拦截 document.cookie 写入，为未显式声明安全属性的 Cookie 自动补齐
// Secure（仅 HTTPS 页面）与 SameSite=Lax，覆盖三方库直接写入的 Cookie
// （如 @aligov/global-locale 写入的 x-hng 语言 Cookie，其 API 无法传入安全标志）。
// 注意：HttpOnly 只能由服务端通过 Set-Cookie 下发，JS 端无法设置。

const originalDescriptor =
  Object.getOwnPropertyDescriptor(Document.prototype, "cookie") ||
  Object.getOwnPropertyDescriptor(HTMLDocument.prototype, "cookie");

if (originalDescriptor && originalDescriptor.set && originalDescriptor.get) {
  Object.defineProperty(document, "cookie", {
    get() {
      return originalDescriptor.get.call(document);
    },
    set(cookieString) {
      const str = String(cookieString);
      let patched = str;
      if (!/;\s*secure(\s*;|\s*$)/i.test(patched) && window.location.protocol === "https:") {
        patched += "; Secure";
      }
      if (!/;\s*samesite\s*=/i.test(patched)) {
        patched += "; SameSite=Lax";
      }
      return originalDescriptor.set.call(document, patched);
    },
    configurable: true,
  });
}

export {};
